import { defineComponent } from 'vue';
import ModalOverlay from '~/components/common/ModalOverlay.vue';
import PricingSection from '~/components/sections/PricingSection.vue';
import { sleep } from '~/pages/members/card.vue';
export default defineComponent({
  name: 'PlanChangeModal',
  components: {
    ModalOverlay,
    PricingSection
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    plans: {
      type: Array,
      required: true
    },
    plan: {
      type: Object,
      required: true
    },
    checkInsufficientFunds: {
      type: Function,
      required: true
    },
    balanceCheck: {
      type: Object
    }
  },
  data() {
    return {
      newPlanSelected: false,
      planPickerCycle: this.plan.billingCycle,
      planPickerPlan: this.plan.selectedPlan
    };
  },
  watch: {
    open(newVal) {
      if (!newVal) {
        this.newPlanSelected = false;
        this.planPickerCycle = this.plan.billingCycle;
        this.planPickerPlan = this.plan.selectedPlan;
      }
    }
  },
  methods: {
    async changeBank() {
      this.$emit('update:open', false);
      await this.$nextTick();
      this.$emit('relinkPlaid');
    },
    async changePlanIfSufficient() {
      var _a, _b, _c, _d;
      this.newPlanSelected = true;
      await this.checkInsufficientFunds(this.plans[this.planPickerPlan].price[this.planPickerCycle]);
      if (((_a = this.balanceCheck) === null || _a === void 0 ? void 0 : _a.success) && !((_b = this.balanceCheck) === null || _b === void 0 ? void 0 : _b.insufficient)) {
        await this.changePlan();
      } else if (((_c = this.balanceCheck) === null || _c === void 0 ? void 0 : _c.success) && ((_d = this.balanceCheck) === null || _d === void 0 ? void 0 : _d.bypassPlaidBalanceCheck)) {
        await this.changePlan();
      }
    },
    async changePlan() {
      var _a, _b;
      if (((_a = this.balanceCheck) === null || _a === void 0 ? void 0 : _a.insufficient) && !((_b = this.balanceCheck) === null || _b === void 0 ? void 0 : _b.bypassPlaidBalanceCheck)) {
        return;
      }
      this.$emit('update:plan', {
        ...this.plan,
        billingCycle: this.planPickerCycle,
        selectedPlan: this.planPickerPlan
      });
      await this.$nextTick(); // let the plan prop update
      await this.$axios.$put('/api/members/profile/plan', {
        plan: this.plan,
        planName: this.plans[this.planPickerPlan].name
      });
      this.$emit('update:open', false);
      await sleep(300); // let the modal fade out
    }
  }
});